import { render } from "./OverlayTooltips.vue?vue&type=template&id=072d716e&scoped=true"
import script from "./OverlayTooltips.vue?vue&type=script&lang=js"
export * from "./OverlayTooltips.vue?vue&type=script&lang=js"

import "./OverlayTooltips.vue?vue&type=style&index=0&id=072d716e&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072d716e"]])

export default __exports__